// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"77cf74d9","225":"ab127ce9","294":"ea09e109","429":"72b1207c","894":"ea09e109","922":"2fa7c6cc","927":"0932cb03"}[chunkId] + ".chunk.css";
};